export default "__VITE_PUBLIC_ASSET__d28016bc__"